module.exports = __webpack_public_path__ + "static/media/lmbc2.794586ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lmbc2.jpg
// module id = 116
// module chunks = 0